// todo si può condividere?
import {useEffect, useState} from "react";
import {preloadImage} from "@commons/utils/util";
import {selectToken} from "@commons/core.slice";
import {TokenRecord} from "@commons/mapping/TokenRecord";
import {LavoratoreRecord} from "@commons/mapping/LavoratoreRecord";
import {config} from "@commons/config.instance";
import {useAppSelector} from "@hooks/redux-hooks/hooks";

export const useFotoLavoratore = (contratto: LavoratoreRecord | null) => {
    const localToken: TokenRecord | null = useAppSelector(selectToken);
    const [srcFoto, setSrcFoto] = useState<string | null>(null)
    useEffect(() => {
        preload(contratto, localToken);
    }, [contratto, localToken]);

    function preload(contratto: LavoratoreRecord | null, localToken: TokenRecord | null, reload: boolean = false) {
        if (contratto && localToken) {
            const nowId = (new Date()).getTime();
            const src = config.getBaseUrl('FPNet') + `/lavoratore/anagrafe/${contratto.codiceFiscale}-${contratto.idAziendaMaster}/foto?auth_token=${localToken.token}${reload ? '&nowId=' + nowId : ''}`;
            preloadImage(src).then((img) => {
                setSrcFoto(src);
            }, () => {
                setSrcFoto(null)
            })
        }
    }

    // A function to force refetch the query
    const refetch = () => {
        preload(contratto, localToken, true);
    }
    return {srcFoto, refetch};
}